import { omit, pickBy } from "lodash";
import {
  Element,
  ElementAllowAttributes,
  ElementDefinition,
  ElementType,
} from "..";

const WHITELIST = ["mj-class", "css-class"];

export const formateBasicBlockAttribute = (
  node: {
    attributes: Parameters<
      ElementDefinition["render"]
    >[0]["node"]["attributes"];
    type: Element["type"];
  },
  mode?: "testing" | "production"
): Parameters<ElementDefinition["render"]>[0]["node"]["attributes"] => {
  switch (node.type) {
    case ElementType.TEXT:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Text);
    case ElementType.WRAPPER:
    case ElementType.SECTION:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Section);
    case ElementType.COLUMN:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Column);
    case ElementType.BUTTON:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Button);
    case ElementType.DIVIDER:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Divider);
    case ElementType.GROUP:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Group);
    case ElementType.HERO:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Hero);
    case ElementType.IMAGE:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Image);
    case ElementType.NAVBAR:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Navbar);
    case ElementType.NAVBAR_LINK:
      return deleteNoAllowKey(
        node.attributes,
        ElementAllowAttributes.NavbarLink
      );
    case ElementType.SOCIAL:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Social);
    case ElementType.SOCIAL_ELEMENT:
      return deleteNoAllowKey(
        node.attributes,
        ElementAllowAttributes.SocialElement
      );
    case ElementType.SPACER:
      return deleteNoAllowKey(node.attributes, ElementAllowAttributes.Spacer);
    case ElementType.RAW:
      if (mode === "production") {
        return omit(
          deleteNoAllowKey(node.attributes, ElementAllowAttributes.Raw),
          "css-class"
        );
      }
      return node.attributes;
  }
  return node.attributes;
};

export const deleteNoAllowKey = (
  attributes: Parameters<ElementDefinition["render"]>[0]["node"]["attributes"],
  allowAttributes: Record<string, string>
) => {
  return pickBy(attributes, (val, key) => {
    if (WHITELIST.includes(key)) return true;

    return Object.keys(allowAttributes).includes(key);
  });
};
